module.exports = __webpack_public_path__ + "img/mdi_guest-room-outline-blue.e3f56991.svg";